import template from './auditresultsummary.html';
import controller from './auditresultsummary.controller';
import './auditresultsummary.styl';

let auditresultsummaryComponent = {
  restrict: 'E',
  bindings: {},
  template,
  controller,
  controllerAs: 'vm'
};

export default auditresultsummaryComponent;



// WEBPACK FOOTER //
// ./client/app/common/reports/auditresultsummary/auditresultsummary.component.js